
import { Box, Button, CardContent, Divider, Grid, Dialog, DialogActions, DialogTitle, TextField, DialogContent, Typography, List, ListItem, ListItemText, ListItemSecondaryAction, IconButton } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '@mui/material/Autocomplete';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import 'react-html5-camera-photo/build/css/index.css';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import FilesPreview from 'src/components/FilePreview';
import axios from 'src/utils/axios';
import { loadFotograf } from 'src/utils/storage/StrPhoto';


const styles = {
  root: (theme) => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  }),
  gridList: {
    width: 500,
    height: 450,
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }),
  content: {
    minHeight: 330,
  },
  divider: {
    backgroundColor: '#FF9800'
  },
  formControl: (theme) => ({
    marginTop: theme.spacing(2),
    width: '100%'
  })
};

function Detay({ className, FisNo, readonly, tasks, ...rest }) {
  const [Loading, setLoading] = useState(true);
  const [openCam, setOpenCam] = useState(false);
  const [openFile, setOpenFile] = useState(false);
  const [DosyaTipi, setDosyaTipi] = useState();
  const [DosyaIsmi, setDosyaIsmi] = useState("");
  const [responseMessage, setresponseMessage] = useState({ ErrorCode: "0", ErrorDescription: "İşleminiz başarı ile gerçekleştirildi." });
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const [files, setFiles] = useState([]);
  const [CCFilePopupOpen,setCCFilePopupOpen] = React.useState(false);
  const [uploadFilePopUp, setUploadFilePopUp] = React.useState(false);
  const [selectedFiles, setSelectedFiles] = React.useState([]);
  const [isDragActive, setIsDragActive] = React.useState(false);
  const fileInputRef = React.useRef(null);
  const MAX_FILE_SIZE = 50000000;

  const addSelectedFiles = (fileList) => {
    const incoming = Array.from(fileList || []);
    const validFiles = incoming.filter((file) => file.size <= MAX_FILE_SIZE);
    if (validFiles.length > 0) {
      setSelectedFiles((prev) => [...prev, ...validFiles]);
    }
  };

  const handleDropFiles = (event) => {
    event.preventDefault();
    setIsDragActive(false);
    addSelectedFiles(event.dataTransfer.files);
  };

  const handleRemoveSelectedFile = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const DosyaTipihandleChange = (event) => {
    var index = event.target.selectedIndex;
    setDosyaIsmi(event.target[index].text);
    setDosyaTipi(event.target.value);
  };
  const handleChangeDosyaIsmi = (event) => {
    const { value } = event.target;
    setDosyaIsmi(value);
  }
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const handleCamOpen = () => {
    if (DosyaTipi === undefined) {
      setresponseMessage({ ErrorCode: 10, ErrorDescription: "Lütfen Dosya Tipi Seçiniz!..." })
      setUyariTip("error");
      setUyari(true);
      return;
    }
    setOpenCam(true);
  }
  const handleCamClose = (type) => {
    if (type === 'file') {
      setOpenFile(false);
    } else {
      setOpenCam(false);
    }
    setLoading(true);
    const localPhotos = loadFotograf(FisNo);
    setFiles(localPhotos);
    axios.get('/GetArtemisDosyaListe/' + FisNo).then((response) => {
      if (response.data === "") {
        setLoading(false);
        setFiles(localPhotos);
      } else {
        const Deger = response.data;
        setFiles([...Deger, ...localPhotos]);
        setLoading(false);
      }
    });
  }
  const handleFileOpen = () => {
    if (DosyaTipi === undefined) {
      setresponseMessage({ ErrorCode: 10, ErrorDescription: "Lütfen Dosya Tipi Seçiniz!..." })
      setUyariTip("error");
      setUyari(true);
      return;
    }
    setOpenFile(true);
  }
  const handleFileClose = (dataUri) => {
    handleCamClose('file');
  }
  const handleCCFileClose = () => {
    setCCFilePopupOpen(false);
  }
  
  const fetchPhotos = (mounted) => {
    setLoading(true);
    const localPhotos = loadFotograf(FisNo);
    setFiles(localPhotos);
    axios.get('/GetArtemisDosyaListe/' + FisNo).then((response) => {
      if (mounted) {
        if (response.data === "") {
          setFiles(localPhotos);
          setLoading(false);
        } else {
          const Deger = response.data;
          setFiles([...Deger, ...localPhotos]);
          setLoading(false);
        }
      }
    });
  };
  useEffect(() => {
    let mounted = true;
    // setLoading(true);
    fetchPhotos(mounted);
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line
  }, [FisNo]);
  return (
    <div>
      {
        uyari ?
          <Alert onClose={uyariKapat} open={uyari} message={responseMessage.ErrorDescription} variant={uyariTip} />
          : <div></div>
      }
      <Grid container spacing={1} justifyContent="space-between">
      
      <Dialog
      open={uploadFilePopUp}
      onClose={() => setUploadFilePopUp(false)}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle sx={{ width: '100%' }} >Dosya Yükle</DialogTitle>
      <DialogContent>
        <Grid style={{ paddingTop: 20 }} size={12}>
          <Autocomplete
            id="combo-box-demo"
            fullWidth
            disableClearable
            options={[]}
            getOptionLabel={(i) => i.aciklama}
            value={[] || null}
            size="small"
            renderInput={(params) => <TextField {...params} variant="outlined" label="Dosya Tipi" />}
            // onChange={(event, val) => {
            //   setSelectedFileType(val);
            // }}
          />
        </Grid>
        <Grid container spacing={2} style={{ paddingTop: 20 }}>
          <Grid
            size={{
              xs: 12,
              md: 12
            }}>
            <input
              ref={fileInputRef}
              type="file"
              multiple
              hidden
              onChange={(event) => {
                addSelectedFiles(event.target.files);
                event.target.value = '';
              }}
            />
            <Box
              onClick={() => fileInputRef.current?.click()}
              onDragOver={(event) => { event.preventDefault(); setIsDragActive(true); }}
              onDragLeave={() => setIsDragActive(false)}
              onDrop={handleDropFiles}
              sx={{
                minHeight: 200,
                maxHeight: 250,
                border: '2px dashed',
                borderColor: isDragActive ? '#FF9800' : '#bdbdbd',
                borderRadius: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                backgroundColor: isDragActive ? 'rgba(255,152,0,0.05)' : 'transparent',
                transition: 'all 0.2s ease',
                p: 2
              }}
            >
              <Typography sx={{ color: 'text.secondary', textAlign: 'center' }}>
                {selectedFiles.length > 0 ? `${5 - selectedFiles.length} ekle` : 'Dosyayı sürükleyip bırakın ya da tıklayın'}
              </Typography>
            </Box>
            {selectedFiles.length > 0 && (
              <List dense sx={{ mt: 1 }}>
                {selectedFiles.map((file, index) => (
                  <ListItem key={index} disablepadding>
                    <ListItemText primary={file.name} />
                    <ListItemSecondaryAction>
                      <IconButton size="small" onClick={() => handleRemoveSelectedFile(index)}>
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
              </List>
            )}
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              sx={{ mt: 2 }}
              disabled={selectedFiles.length === 0}
              onClick={() => setSelectedFiles([])}
            >
              Yükle
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        </DialogActions>
        </Dialog>
      </Grid>

      <Divider sx={styles.divider} />
      <CardContent sx={styles.content}>
        {
          Loading ?
            <CircularProgress status={'loading'} style={{ marginLeft: '50%' }} />
            : <div></div>
        }
        <FilesPreview FisNo={FisNo} files={files} fetchPhotos={fetchPhotos} setLoading={setLoading} />
      </CardContent>

    </div>
  );
}

Detay.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({ tasks: state.tasks1 })
)(Detay);
